/**
 * 小能客服模块接入
 * @author lianghua.fu
 * @date 2018-09-06 11:38:27
 */
$.module('MM.user.kefu', function () {
  var ACTIONS = {};
  var isInit = false;
  var isLoading = false;
  var loadTimer = null;

  function _init(cb) {
    if (!isInit) {
      (function (w, d, e, x) {
        w[e] = function () {
          w.cbk = w.cbk || [];
          w.cbk.push(arguments);
        };
        x = d.createElement('script');
        x.async = true;
        x.id = 'zhichiScript';
        x.className = 'zhiCustomBtn'; //该class绑定到自定义按钮上 第一步
        x.src =
          'https://meme.soboten.com/chat/frame/v7/entrance.js?sysnum=f078e8bd8b19464aa945610870c9b3fe';
        d.body.appendChild(x);
      })(window, document, 'zc');
      zc('config', {
        color: '6C6FFF',
        show_manual: 0,
        show_face: 1,
        msg_flag: 0,
        show_evaluate: 0,
        type: 2,
        custom: true,
        width: '600',
        // "manual": true, //设置成手动初始化
        groupid: '95368b3b5a3d4aa7b93b132dbefc9bf6',
        container_style: 'right:70px;bottom:10px;',
      });
      isInit = true;
    }

    if (MM.user.isLogin()) {
      zc('config', {
        partnerid: MM.user.getUserId() + '',
        uname: MM.user.getUserInfo().nick_name,
        face: MM.user.getUserInfo().pic,
        remark: '财富等级：' + MM.user.getRichLv(),
      });
    } else {
      zc('config', {
        partnerid: '',
        uname: '未登录用户',
        remark: '未登录用户',
      });
    }
    // _loadScript(cb);
  }

  function _loadScript(cb) {}

  function _show() {
    if (!MM.user.isLogin()) {
      MM.user.popupLogin();
      return;
    }

    _init();
    // zc("frame_manual", function (res) {
    //     // MM.ui.messager.success('ok')
    //     zc('frame_status', function(data) {
    //         console.log('frame_status',data)
    //         MM.ui.messager.success('frame_status:'+data)
    //     })
    // })
    zc('dynamic_ready');
    zc('frame_ready', function () {
      zc('frame_status', function (data) {
        console.log('frame_status', data);
      });
    });
  }

  function _showKefu() {
    _show();
  }

  function _showYunying() {
    _show();
  }

  function _showGonghui() {
    _show();
  }

  return {
    init: _init,
    showKefu: _showKefu,
    showYunying: _showYunying,
    showGonghui: _showGonghui,
  };
});
